import { DateTime } from "luxon";

export function getDunningStatusLabel(dunningDisabled: boolean, dunningPostponedUntil?: DateTime | null): string {
  if (dunningDisabled) {
    return "Deaktiviert";
  }
  if (dunningPostponedUntil && dunningPostponedUntil > DateTime.now()) {
    return `Inaktiv bis ${dunningPostponedUntil.toFormat("dd.MM.yyyy")}`;
  }
  return "Aktiv";
}
